var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Customer Enrollments")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"col-xs-12"},[(_vm.customer.enrollments)?_c('order-list',{attrs:{"orders":_vm.customer.enrollments}}):_c('div',[_vm._v("No Current Enerollments")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f67a4e04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/CustomerProfile/CustomerOrderInfo.vue
// module id = ZiDN
// module chunks = 3